import * as React from 'react';

import { StandardPageLayout } from 'ui/components';
import { useEffect } from 'react';
import { toggleHelpCenterVisibility } from '../../../utils';
import { CareerFooter } from '../CareerFooter';
import { Helmet } from 'react-helmet';
import { getPageTitle } from 'career-explorer/utils';

export interface CareerStandardLayoutProps {
  mainClassName?: string;
  pageTitleValues?: { [key: string]: string };
  children?: React.ReactNode;
  headerComponent?: React.ReactNode;
  containerPaddingEnabled?: boolean;
}

export const CareerStandardLayout: React.FC<CareerStandardLayoutProps> = ({
  mainClassName,
  pageTitleValues,
  children,
  headerComponent,
  containerPaddingEnabled = false,
}) => {
  useEffect(() => {
    toggleHelpCenterVisibility('hide');
    return () => {
      toggleHelpCenterVisibility('show');
    };
  }, []);

  return (
    <StandardPageLayout
      mainClassName={mainClassName}
      headerComponent={headerComponent}
      containerPaddingEnabled={containerPaddingEnabled}
      footerComponent={<CareerFooter />}
    >
      <Helmet>
        <title>{getPageTitle(pageTitleValues)}</title>
      </Helmet>
      {children}
    </StandardPageLayout>
  );
};

export default CareerStandardLayout;
